import type { Tool } from '@ace-tracker/shared';

/**
 * One series color per tool, theme-aware via the CSS variables in index.css.
 * Shared by every view that puts tools side by side (All tools, Executive).
 */
export const TOOL_COLORS: Record<Tool, string> = {
  copilot: 'var(--tool-copilot)',
  'claude-code': 'var(--tool-claude-code)',
  codex: 'var(--tool-codex)',
  kiro: 'var(--tool-kiro)',
  gemini: 'var(--tool-gemini)',
};
